export function getTenantFromGroups(groups: string[]): string {
  const theTenant = groups?.find((aGroup) => aGroup.startsWith("tenant:"))?.replace("tenant:", "");
  if (!theTenant) {
    throw new Error("No tenant found for the current authenticated user");
  }
  return theTenant;
}
